
import AttachSquare from "../../../assets/filled/AttachSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AttachSquareIcon({ className, dataTestid = "AttachSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <AttachSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
